import React from 'react';
import cn from '@/utils/cn';
import { IHolisticRubricDescription } from '../../useQuestionRubric';
import styles from './HolisticRubric.module.scss';

type PreviewDescriptionCellProps = {
  data: IHolisticRubricDescription,
  locale?: Lowercase<Locale>,
};

const PreviewDescriptionCell = ({
  data,
  locale = 'en',
}: PreviewDescriptionCellProps) => {
  const { description_en: descriptionEn, description_es: descriptionEs } = data;
  return (
    <div
      className={cn('allow-list-style', styles.holisticDescriptionCell)}
      dangerouslySetInnerHTML={{ __html: (locale === 'en' ? descriptionEn : descriptionEs) }}
    />
  );
};

export default PreviewDescriptionCell;
